// extracted by mini-css-extract-plugin
module.exports = {"admin":"AccountRow_admin__2XNG7"};